import { createStyles } from '@mantine/core';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    padding: 20,
    overflowY: 'auto',
  },
});

export default styles;
